module.exports = __webpack_public_path__ + "img/groups-icon.1ecccf70.svg";